export default __webpack_public_path__ + "static/media/blog-bg-cards.97da6080.jpg";